import Shimmer from "../Shimmer/shimmer";
import gotoIcon from "../../assets/icons/lsq_goto.svg";
import resetIcon from "../../assets/icons/lsq_reset.svg";
import emptyIllustration from "../../assets/illustrations/empty.svg";
import errorIllustration from "../../assets/illustrations/error.svg";
import { handleWidgetClick } from "../../Layout/helper";
import { handleListItemClick } from "./helper";
import styles from "./style.module.css";

const ListInterface = ({ data = {} }) => {
  const { list, isListLoading, config, smartviewsConfig, isError, retryHandler, count = 10 } = data;
  const isListEmpty = !isListLoading && !list?.length;

  const handleGoto = () => {
    const { config, id, type } = data;
    handleWidgetClick(config, id, type)
  }

  /*===========================================
  ************* SKELETON LOADER ***************
  ============================================*/
  if (isListLoading)
    return (
      <div className={styles.parentWrapper} data-testid="list-loader">
        <div className={`${styles.heading} ng_sh_sb`}>
          <Shimmer width="60%" height="20px" />
          <Shimmer width="20px" height="20px" />
        </div>

        {[...new Array(count < 10 ? count : 10).fill("_")].map((value, index) => {
          return (
            <div className={styles.shimmerWrapper} key={value + index}>
              <Shimmer width="100%" height="28px" />
            </div>
          )
        })}
      </div>
    )


  /*===========================================
 ************ RETURNING ERROR UI **************
 ============================================*/
  else if (isError)
    return (
      <div className={styles.parentWrapper} data-testid="list-error">
        <div className={`${styles.heading} ng_sh_sb`}>
          <div>{config?.name}</div>
        </div>

        <div className={styles.illustrationWrapper}>
          <img src={errorIllustration} alt="Error" />
          <div className={`${styles.subHeading} ng_p_1_sb`}>Couldn't fetch the data</div>
          <button className={`${styles.retryButton} ng_p_1_b`} onClick={retryHandler}>
            <img src={resetIcon} alt="Reset" />
            <span>Retry</span>
          </button>
        </div>

      </div>
    )


  /*===========================================
  ************ RETURNING LIST UI **************
  ============================================*/
  return (
    <div className={styles.parentWrapper}>
      <div className={`${styles.heading} ng_sh_sb`}>
        <div>{config?.name}</div>
        {!isListEmpty && <img src={gotoIcon} alt={"Goto"} onClick={handleGoto} data-testid="goto-button"/>}
      </div>

      {
        (isListEmpty)
          ? <EmptyListIllustration />
          : <div className={styles.listWrapper}>
            {list?.map((entityDetails, index) => (
              <div
                key={entityDetails?.name + index}
                className={`${styles.listItem} ng_p_1_r`}
                title={entityDetails?.name}
                onClick={()=>handleListItemClick(entityDetails, config, smartviewsConfig)}
              >
                {entityDetails?.name}
              </div>
            ))}
          </div>
      }
    </div>
  )
}

const EmptyListIllustration = () => {
  return (
    <div className={styles.illustrationWrapper}>
      <img src={emptyIllustration} alt="List Empty" />
      <div className={`${styles.subHeading} ng_p_1_sb`}>No data found</div>
    </div>
  )
}

export default ListInterface